// extracted by mini-css-extract-plugin
export var link_list = "link_list-18-";